export const forBusiness_apparel_tips = [
	{
		icon: '✅',
		title: 'tipsData_title1',
		subtitle: 'tipsData_subtitle1',
	},
	{
		icon: '✅',
		title: 'tipsData_title2',
		subtitle: 'tipsData_subtitle2',
	},
	{
		icon: '✅',
		title: 'tipsData_title3',
		subtitle: 'tipsData_subtitle3',
	},
];
